import _get from 'lodash/get';

const typeInProductsApiParsers: any = {};

typeInProductsApiParsers.TypeInProductsListParser = (res: any): any[] => {
  if (!res) {
    return [];
  }

  const data: any[] = res.data?.content?.map((item: any) => {
    return {
      id: _get(item, 'id', ''),
      productName: _get(item, 'name', ''),
      maker: _get(item, 'makerName', '-'),
      makerId: _get(item, 'makerId', null),
      vesselName: _get(item, 'vesselName', '-'),
      category: _get(item, 'categoryName', ''),
      categoryId: _get(item, 'categoryId', null),
      type: _get(item, 'typeName', ''),
      symbol: _get(item, 'symbol', ''),
      typeId: _get(item, 'typeId', null),
      unit: _get(item, 'symbol', '') || '-', // Display symbol in unit column (e.g., "C/kg", "L")
      uomId: _get(item, 'uomId', null),
      groupId: _get(item, 'productGroupId', null),
      status: _get(item, 'active', true),
    };
  });
  return data;
};

export default typeInProductsApiParsers;
